const DEFAULT_INTERVAL_MS = 15000;

// Non-production override for QA, same gating shape as `modules/tenant/resolve.ts:29`. Guarded:
// a blocked-storage browser throws on the property ACCESS, and this runs at module scope.
const readOverrideMs = () => {
  try {
    return process.env.NODE_ENV !== 'production' ? Number(window.localStorage.getItem('livePollIntervalMs')) : NaN;
  } catch {
    return NaN;
  }
};

const overrideMs = readOverrideMs();

export const LIVE_UPDATE_POLL_INTERVAL_MS = overrideMs > 0 ? overrideMs : DEFAULT_INTERVAL_MS;

export const livePollOptions = {
  pollInterval: LIVE_UPDATE_POLL_INTERVAL_MS,
  skipPollAttempt: () => document.visibilityState === 'hidden',
};
